import AdminCommonAPICall from "src/service/AdminAPICalls/AdminCommonAPICall";
import BaseRepository from "../BaseRepository";


class AdminCommonRepository extends BaseRepository {
    getRoleList = async () => {
        return await new AdminCommonAPICall().getRoleList();
    };
    getOrganizationList = async () => {
        return await new AdminCommonAPICall().getOrgList();
    };
   

}

export default AdminCommonRepository;